import { useEffect, useState } from 'react';
import instance from 'api/instance';
import { EstadoData } from '@componentes/Tabla/types';
import { fetchConfig } from 'api/configService';
import useToggle from '@utils/useToggle';
import TablaEspecial from '@componentes/TablaEspecial/TablaEspecial';

export default function EstadoTrafico() {
    const [estado, setEstado] = useState<{ id: number, descripcion: string, carga: number }[]>([])
    const [configLoaded, setConfigLoaded] = useToggle(false);
    const [apiUrlConfig, setApiUrlConfig] = useState('');

    useEffect(() => {
        fetchConfig(setApiUrlConfig, setConfigLoaded);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (configLoaded) {
            const fetchData = async () => {
                const apiUrl = `${apiUrlConfig}infoTramos`;
                instance
                    .get<EstadoData[]>(apiUrl)
                    .then((response) => {
                        const data = response.data.map(ele => {
                            return {
                                id: ele.CODIGO,
                                descripcion: ele.DESCRIPCION,
                                carga: ele.CARGA
                            }
                        })
                        setEstado(data);
                    })
                    .catch((error) => {
                        console.error("Error al hacer la solicitud:", error);
                    });
            };

            fetchData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [configLoaded, apiUrlConfig]);
    return (
        <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
            <div style={{ display: 'flex', justifyContent: 'center', width: '100%', marginBottom: '20px' }} >
                <TablaEspecial info={estado} tipo='Estado de Tráfico' />
            </div>
        </div>
    );
}